"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.75 14.125H6.25C5.8356 14.125 5.43817 14.2896 5.14515 14.5826C4.85212 14.8757 4.6875 15.2731 4.6875 15.6875C4.6875 16.1019 4.85212 16.4993 5.14515 16.7924C5.43817 17.0854 5.8356 17.25 6.25 17.25H43.75C44.1644 17.25 44.5618 17.0854 44.8549 16.7924C45.1479 16.4993 45.3125 16.1019 45.3125 15.6875C45.3125 15.2731 45.1479 14.8757 44.8549 14.5826C44.5618 14.2896 44.1644 14.125 43.75 14.125Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.0417 23.4375H13.6042C13.1898 23.4375 12.7923 23.6021 12.4993 23.8951C12.2063 24.1882 12.0417 24.5856 12.0417 25C12.0417 25.4144 12.2063 25.8118 12.4993 26.1049C12.7923 26.3979 13.1898 26.5625 13.6042 26.5625H37.0417C37.4561 26.5625 37.8535 26.3979 38.1465 26.1049C38.4395 25.8118 38.6042 25.4144 38.6042 25C38.6042 24.5856 38.4395 24.1882 38.1465 23.8951C37.8535 23.6021 37.4561 23.4375 37.0417 23.4375Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.8333 32.75H21.8125C21.6073 32.75 21.4041 32.7904 21.2146 32.8689C21.025 32.9475 20.8527 33.0626 20.7076 33.2076C20.5626 33.3527 20.4475 33.525 20.3689 33.7146C20.2904 33.9041 20.25 34.1073 20.25 34.3125C20.25 34.5177 20.2904 34.7209 20.3689 34.9104C20.4475 35.1 20.5626 35.2723 20.7076 35.4174C20.8527 35.5624 21.025 35.6775 21.2146 35.7561C21.4041 35.8346 21.6073 35.875 21.8125 35.875H28.8333C29.2477 35.875 29.6452 35.7104 29.9382 35.4174C30.2312 35.1243 30.3958 34.7269 30.3958 34.3125C30.3958 33.8981 30.2312 33.5007 29.9382 33.2076C29.6452 32.9146 29.2477 32.75 28.8333 32.75Z",
    fill: fill
  }));
};

exports["default"] = _default;